module.exports = __webpack_public_path__ + "static/ready-player-one-20f6e09c63ca9a9bf66b022b306944e9.jpg";